var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');
var SubSection = require('front/pages/Section/SubSection');
var Utils = require('front/utils/Utils');

var template = require('./PaintingsPopup.jinja');
require('./PaintingsPopup.less');

var PaintingsContentUser = require('front/components/Index/PaintingsContentUser');
var PaintingsContentAll = require('front/components/Index/PaintingsContentAll');


module.exports = SubSection.extend({
    template: template,

    el: '.PaintingsPopup',

    rootUrl: '/',

    events: {
        'click .PaintingsPopup-close': 'close'
    },


    initialize: function (options) {
        _.extend(this, options);

        _.bindAll(this, 'onResize');

        $(window).on('resize', this.onResize);

        SubSection.prototype.initialize.call(this, options);

        //кешируем все вьюхи по картинам, чтобы не пересоздавать их каждый раз и не перекачивать данные при открытии/заркытии попапа
        //а также потому, что у нас потом будут еще картины и надо внутри одного попапа показывать разные, переключаясь между ними
        window.app.state.paintings = window.app.state.paintings || {};

        //ключ вьюхи с картиной (двух типов, прямой линк на конкретного юзера и просто все мазки)
        //их обслуживают разные классы вьюх
        var paintingKey = options.paintingId + '_' + (options.userKey ? options.userKey : 'all');

        if (!window.app.state.paintings[paintingKey]) {
            window.app.state.paintings[paintingKey] = options.userKey ?
                (new PaintingsContentUser({paintingId: options.paintingId, userKey: options.userKey})) :
                (new PaintingsContentAll({paintingId: options.paintingId}));
        }

        //щас эта вьюха всегда одна в рамках открытого попапа, потом она будет меняться стрелками
        this.paintingView = window.app.state.paintings[paintingKey];

        if (options.server) {
            this.$el.hide();
            this.$el.addClass('PaintingsPopup--visible');
            this.$el.outerHeight();
            this.$el.show();
            $('html').addClass('HideGlobalScroll');
        }


        this.onResize();
    },


    onResize: function () {
        if (!app.settings.isMobile) return;

        //формула как в цсс
        var mobileTopOffset = 180;
        var width = (window.innerHeight * (2000 / 1400) - mobileTopOffset * (2000 / 1400)) + 'px';

        //для режима landscape пропорции считаются от ширины и там можно чистым css обойтись
        if (window.innerWidth > window.innerHeight) {
            width = '';
        }

        this.$('.PaintingsPopup-contentInner').css('width', width);
    },


    close: function () {
        Backbone.history.navigate(this.rootUrl + (window.app.data.lang == 'en' ? 'en/' : ''), {trigger: 'true'});
    },


    // renderData: function () {
    //  var newsItem = _.findWhere(this.data, {url: this.options.url});
    //  return {
    //      newsItem: newsItem
    //  };
    // },


    setTitle: function () {
        if (this.userKey) {
            this.$('h1').text(app.settings.isMobile ? 'Вы – соавтор картины!' : 'Вы – соавтор картины!');
        } else {
            this.$('h1').text(app.data.titles[app.data.lang][this.paintingId]);
            //if (app.data.picture.id == this.paintingId) {
            //    this.$('h1').text(app.data.picture.title);
            //} else {
            //    this.$('h1').text(_.findWhere(app.data.past, {id: parseInt(this.paintingId,10)}).title);
            //}
        }
    },


    render: function () {
        console.log('render popup');
        var result = SubSection.prototype.render.call(this);

        this.setTitle();

        return result;
    },


    //вызывается из подвьюхи PaintingsContentUser
    scrollLeft: function (scrollOffset) {
        this.$('.PaintingsPopup-scrollBox').scrollLeft(scrollOffset);
    },


    //вызывается из подвьюхи PaintingsContentUser
    scrollTop: function (scrollOffset) {
        this.$('.PaintingsPopup-scrollBox').scrollTop(scrollOffset);
    },


    activate: function (params) {
        console.log('activate popup');

        return SubSection.prototype.activate.call(this, params)
            .then(function () {
                if (!this.options.inAnimated && !this.options.server) {
                    this.$el.addClass('PaintingsPopup--visible');
                    $('html').addClass('HideGlobalScroll');
                }
                if (this.options.server) {
                    app.vent.trigger('gallery-popup-show');
                }

                this.setTitle();

                this.onResize();


                //просим вьюху отобразить себя в нужном месте попапа
                //если она еще не отрендерена - сама отрендерится
                this.paintingView.activate({$parent: this.$('.PaintingsPopup-contentWrapper'), parent: this});
            }.bind(this));
    },


    deactivate: function (params) {
        console.log('deactivate popup');

        $('html').removeClass('HideGlobalScroll');

        //говорим вьюхе что попап закрывается
        //надо себя отдетачить и все листенеры остановить
        //детачить надо обязательно, иначе контент вместе с попапом накроется тазиком
        this.paintingView.deactivate();

        return SubSection.prototype.deactivate.call(this, params);
    },


    playIn: function (params) {
        console.log('playIn popup');

        var self = this;

        if (this.options.inAnimated) {
            return new Promise(function (resolve) {
                self.$el.outerHeight();
                self.$el.addClass('PaintingsPopup--visible');
                $('html').addClass('HideGlobalScroll');


                setTimeout(function () {
                    app.vent.trigger('gallery-popup-show');
                    resolve();
                }.bind(this), params.duration + 100);
            });
        } else {
            return Utils.createEmptyPromise();
        }
    },


    playOut: function (params) {
        console.log('playOut popup');

        var self = this;

        return new Promise(function (resolve) {
            self.$el.removeClass('PaintingsPopup--visible');

            app.vent.trigger('gallery-popup-hide');

            setTimeout(function () {

                $('html').removeClass('HideGlobalScroll');
                resolve();
            }.bind(this), params.duration + 100);
        });
    },


    viewsRegistration: function () {
    },


    destroy: function () {
        console.log('destroy popup');

        $(window).off('resize', this.onResize);

        return SubSection.prototype.destroy.call(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Index/PaintingsPopup.js
// module id = 35
// module chunks = 0